import React, { useState } from "react";
import { Modal, Form, Row, Col } from "react-bootstrap";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import { useForm } from "react-hook-form";
import { renderGlobalModal } from "../../utils/helpers";
import PropTypes from "prop-types";

const Details = (props) => {

  const { userdata } = props;
  const { register, formState: { errors }, handleSubmit } = useForm({ mode: 'onChange' });
  const [loading, setLoading] = useState(false);

  const onSubmit = (data) => {
    setLoading(true)
    const request = {};
    request.mentee_id = userdata.mentee_id;
    request.mentor_id = userdata.mentor_id;
    request.review = data.review;
    request.user_role = "Mentee";
    agent
      .post(API.LOAD_CUSTOMER + "/updateReview", request)
      .then((res) => {
        setLoading(false)
        renderGlobalModal({ message: res?.data?.message })
        props.refreshList();
        props.onHide();
      })
      .catch((err) => {
        setLoading(false)
        renderGlobalModal({ message: "Something went wrong.Please try again." })
      });
  };

  return (

    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered className="calendar-modal"
    >
      <Modal.Header closeButton></Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mentor_detail align-items-center">
            <Col sm={12}>
              <label className="form-label" htmlFor="review">Write a review*</label>
              <Form.Control
                as="textarea"
                className={
                  errors.review ? "form-control is-invalid" : "form-control"
                }
                name="review"
                defaultValue={userdata.mentee_review}
                aria-invalid={errors.review ? "true" : "false"}
                {...register("review", {
                  required: true,
                  maxLength: 600,
                  validate: {
                    whiteSpace: (value) =>
                      value.trim() ? true : "White spaces not allowed.",
                  },
                })}
              />
              {errors?.review && errors?.review?.type === "required" && (
                <label className="customeValidationText text-left" htmlFor="review">
                  Please enter review
                </label>
              )}
              {errors?.review && errors?.review?.type === "whiteSpace" && (
                <label className="customeValidationText text-left" htmlFor="review">
                  White spaces not allowed
                </label>
              )}
              {errors?.review && errors?.review?.type === "maxLength" && (
                <label className="customeValidationText text-left" htmlFor="review">
                  Review should not more than 600 characters
                </label>
              )}
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="form-group mt-3 text-left">
                <button
                  className="btn loginsubmit nextbtn ml-2"
                  type="submit"
                  disabled={loading}                  >
                  {loading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

Details.propTypes = {
  userdata: PropTypes.shape({
    mentee_id: PropTypes.number.isRequired,
    mentor_id: PropTypes.number.isRequired,
    mentee_review: PropTypes.string,
  }).isRequired,
  refreshList: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default Details;
